<!--
 * @Descripttion: 
 * @Author: lijingjing56
 * @Date: 2024-11-19 11:56:25
 * @LastEditors: lijingjing56
 * @LastEditTime: 2024-11-27 14:26:32
-->
<template>
  <div>
  <h2><div class="section-title-container">{{text}}</div></h2>
  <div v-if="mess" class="section-title-detail">{{ mess }}</div>
  <cloud-button v-if="btn.text"
              :text="btn.text"
              :class="btn.center && 'centerBtn'"
              :handleClick="() => open(btn.router)"
            ></cloud-button>
</div>
</template>

<script>
import cloudButton from "./cloudButton.vue";
export default {
name: "sectionTitle",
components: {
    cloudButton,
  },
props: {
  text: {
    type: String,
    default: ""
  },
  mess: {
    type: String,
    default: ""
  },
  btn: {
    type: Object,
    default: () => {
      return {
        text:'',
        router:'',
        center:true
    }}
  },
},
methods: {
    open(url) {
      if (!url) return
      window.open(url, '_blank')
    },
  },
};
</script>

<style lang="scss" scoped>
.section-title-container {
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 45px;
  font-size: 42px;
  font-family: PingFangSC;
  font-weight: 400;
  color: #111;
}
.section-title-detail{
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #888;
  margin-top:40px;
  font-size: 16px;
}
.centerBtn{
  margin:40px auto;
}
</style>

